import React, { useState } from "react";
import { ChevronDown, ChevronRight, Download, Network } from "lucide-react";

const PDF = "/docs/SitePro_Site_Manager_Mindmap.pdf";

export const SiteManagerMindmap = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-amber-200 rounded-xl overflow-hidden bg-white" data-testid="site-mindmap-section">
      <button onClick={() => setOpen((o) => !o)} className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-amber-50/50" data-testid="site-mindmap-toggle">
        <span className="flex items-center gap-2 font-semibold text-slate-800">
          <Network className="w-4 h-4 text-amber-600" />Site Manager Mindmap — everything at a glance
        </span>
        {open ? <ChevronDown className="w-5 h-5 text-slate-400" /> : <ChevronRight className="w-5 h-5 text-slate-400" />}
      </button>
      {open && (
        <div className="px-4 pb-5 pt-1 space-y-4">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <p className="text-sm text-slate-700">Every area a site manager uses, its main tasks, and where to find it in the menu.</p>
            <a href={PDF} download className="inline-flex items-center rounded-md bg-amber-600 hover:bg-amber-700 text-white text-sm font-medium px-3 py-2" data-testid="site-mindmap-download">
              <Download className="w-4 h-4 mr-2" />Download PDF
            </a>
          </div>
          <div className="overflow-x-auto">
            <img src="/docs/flow/site-manager-mindmap.svg" alt="Site Manager mindmap" className="w-full min-w-[760px] rounded-lg border border-slate-200 bg-white p-2" data-testid="site-mindmap-image" />
          </div>
        </div>
      )}
    </div>
  );
};
